export default {
  title: ['Titre du module', "Module's title"],
};
